import * as v from 'valibot'

/** Reader-facing genre codes; labels belong to the UI's six-language messages. */
export const NOVEL_GENRES = Object.freeze([
  'romantasy',
  'seafaring',
  'enemies_to_lovers',
  'winter_fantasy',
  'second_chances',
  'gothic_mystery',
  'found_family',
])

export const NovelGenres = v.pipe(
  v.array(v.picklist(NOVEL_GENRES)),
  v.maxLength(6),
  v.check(genres => new Set(genres).size === genres.length, 'Duplicate genre'),
)

export const NovelSynopsis = v.pipe(v.string(), v.maxLength(1200))

export const NOVEL_STOREFRONT_LOCALES = Object.freeze(['en', 'zh', 'ja', 'ko', 'es', 'pt'])

/** A complete reader-only translation, with stable ids linking back to source artwork. */
export const NovelStorefrontLocale = v.strictObject({
  title: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  teaser: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  synopsis: v.pipe(v.string(), v.minLength(1), v.maxLength(1200)),
  character_profiles: v.array(v.strictObject({
    id: v.pipe(v.string(), v.minLength(1)),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
    public_profile: v.pipe(v.string(), v.minLength(1), v.maxLength(4000)),
  })),
  opening_location_name: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
})

export const NovelStorefrontQuery = v.object({
  locale: v.optional(v.picklist(NOVEL_STOREFRONT_LOCALES), 'en'),
})

/** Optional pack-level display metadata. Omission means no reader-facing copy. */
export const NovelStorefrontFields = v.object({
  genres: v.optional(NovelGenres, () => []),
  synopsis: v.optional(NovelSynopsis, ''),
  storefront_locales: v.optional(v.record(v.picklist(NOVEL_STOREFRONT_LOCALES), NovelStorefrontLocale), () => ({})),
})

/** Applies to each characters[] entry. This flag is public, not a gameplay rule. */
export const NovelCharacterStorefrontFields = v.object({
  romanceable: v.optional(v.boolean(), false),
})
